import React, { useEffect, useState } from 'react';
import { Box, TextField, Chip, Paper, Stack, IconButton, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { supabase } from '../supabaseClient';

export function KeywordSelector({
  keywords, setKeywords
}: {
  keywords: string[];
  setKeywords: (k: string[]) => void;
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [presetKeywords, setPresetKeywords] = useState<string[]>([]);

  useEffect(() => {
    async function fetchKeywords() {
      try {
        console.log('키워드 데이터 가져오는 중...'); // 디버깅 로그
        const { data, error } = await supabase.from('keywords').select('name');
        
        if (error) {
          console.error('키워드 로딩 에러:', error);
          return;
        }
        
        if (data) {
          console.log('키워드 데이터:', data); // 디버깅 로그
          setPresetKeywords(data.map((k: any) => k.name));
        }
      } catch (err) {
        console.error('키워드 로딩 실패:', err);
      }
    }
    
    // 컴포넌트 마운트 시에만 실행
    fetchKeywords();
  }, []);

  const filtered = presetKeywords.filter(
    k => k.toLowerCase().includes(search.toLowerCase()) && !keywords.includes(k)
  );

  const handleAdd = (k: string) => {
    if (keywords.length >= 10) {
      alert('키워드는 최대 10개까지 추가할 수 있습니다.');
      return;
    }
    if (keywords.includes(k)) {
      alert('이미 추가된 키워드입니다.');
      return;
    }
    setKeywords([...keywords, k]);
    setSearch('');
    setOpen(false);
  };
  
  const handleRemove = (k: string) => {
    setKeywords(keywords.filter(x => x !== k));
  };

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" mb={1}>
        {keywords.map(k => (
          <Chip
            key={k}
            label={k}
            onDelete={() => handleRemove(k)}
            sx={{ borderRadius: 2, fontWeight: 500, fontSize: 15, bgcolor: '#f7f7f7' }}
          />
        ))}
        <Box
          sx={{
            border: '1.5px dashed #bbb',
            borderRadius: 2,
            px: 2, py: 1,
            cursor: 'pointer',
            color: '#888',
            fontWeight: 500,
            fontSize: 15,
            bgcolor: open ? '#f5f5f5' : '#fff'
          }}
          onClick={() => setOpen(o => !o)}
        >
          + 키워드 추가
        </Box>
      </Stack>
      {open && (
        <Paper sx={{ mt: 1, p: 2, borderRadius: 2, boxShadow: 2, maxWidth: 400 }}>
          <TextField
            autoFocus
            fullWidth
            placeholder="키워드 검색"
            value={search}
            onChange={e => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setOpen(false)}>
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
            sx={{ mb: 1 }}
          />
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {filtered.length === 0 && (
              <Box sx={{ color: '#aaa', fontSize: 15, px: 1 }}>
                {presetKeywords.length === 0 ? '키워드 로딩 중...' : '검색 결과 없음'}
              </Box>
            )}
            {filtered.slice(0, 5).map(k => (
              <Chip
                key={k}
                label={k}
                onClick={() => handleAdd(k)}
                sx={{
                  borderRadius: 2,
                  fontWeight: 500,
                  fontSize: 15,
                  bgcolor: '#f7f7f7',
                  cursor: 'pointer',
                  mb: 1
                }}
              />
            ))}
          </Stack>
        </Paper>
      )}
    </Box>
  );
}